'use client'
import Navbar from '@/screens/dashboard/newUi/Navbar'
import PropertyDetailsCard from '@/screens/dashboard/newUi/PropertyDetailsCard'
import BreadCums from './section/BreadCumb'
import { usePropertyDetails } from './usePropertyDetails'

import SectionContainer from '@/components/SectionContainer'
import SimilarProperties from './section/SimilarProperties'
import { useDeferredPropertyExtras } from './useDeferredPropertyExtras'
import {
  DesktopBookingSidebar,
  DesktopPropertyDetailsContent,
  MobilePropertyDetailsContent,
} from './PropertyDetailsContentSections'

import PropTypes from 'prop-types'
import { useEffect, useMemo } from 'react'

function getReviewCounts(dataReview) {
  const hostFullyCount = Number(
    Object.hasOwn(dataReview, 'hosfully_review_count') &&
      !Number.isNaN(Number(dataReview?.hosfully_review_count))
      ? dataReview.hosfully_review_count
      : 0,
  )

  const airbnbCount = Number(
    Object.hasOwn(dataReview, 'airbnb_review_count') &&
      !Number.isNaN(Number(dataReview?.airbnb_review_count))
      ? dataReview.airbnb_review_count
      : 0,
  )

  return {
    hostFullyCount,
    airbnbCount,
    totalCount: dataReview?.count ?? hostFullyCount + airbnbCount,
  }
}


const PropertyDetailsSectionWrapper = ({
  id,
  city,
  slug,
  initialGuests,
  initialCheckin,
  initialCheckout,
  propertiesDetailsData,
  propertiesDetailsLoading,
  reviewsDataNewProps,
  loadingReviews,
  similarData,
  loadingSimilar,
}) => {
  const {
    reviewsData,
    isReviewsLoading,
    similarPropertiesData,
    isSimilarLoading,
  } = useDeferredPropertyExtras({
    id,
    reviewsData: reviewsDataNewProps,
    loadingReviews,
    similarData,
    loadingSimilar,
  })

  const {
    // UI state
    showGuestsDropdown,
    setShowGuestsDropdown,
    showGuestsDropdownMobile,
    setShowGuestsDropdownMobile,

    // Platform ratings
    platformData,
    platformDataMobile,
    skeletonData,

    // Property details
    propertyDetails,

    // Review categories
    reviewCategories,
    reviewCategoriesMobile,
  } = usePropertyDetails(propertiesDetailsData, reviewsData)

  const words = propertiesDetailsData?.data?.summary?.split(' ')
  const isLong = words?.length > 60
  const propertyData = propertiesDetailsData?.data

  const dataReview = reviewsData?.data ?? {}
  const reviewCounts = useMemo(() => getReviewCounts(dataReview), [dataReview])

  useEffect(() => {
    const scrollContainer = document.scrollingElement ?? document.documentElement

    scrollContainer.scrollTo({ top: 0, left: 0, behavior: 'auto' })
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }, [slug])

  return (
    <div>
      <Navbar loading={propertiesDetailsLoading} isPropertyDetailPage={true} />
      <section className='max-w-[1440px] mx-auto'>
        <SectionContainer className='md:pt-20 max-w-[1300px] w-full md:px-3 lg:p-5 max-md:p-0 md:relative max-md:overflow-x-hidden'>
          <BreadCums
            url={'/'}
            loading={propertiesDetailsLoading}
            data={propertiesDetailsData}
          />

          <div className='max-md:hidden mb-10'>
            <PropertyDetailsCard
              data={propertyData}
              loading={propertiesDetailsLoading}
              slug={slug}
            />
          </div>

          <div className='md:flex justify-between max-md:gap-1 xl:gap-8 w-full '>
            <div className='max-xl:max-w-[60%] max-md:max-w-full md:flex-1 xl:flex-[60%] md:me-3'>
              <MobilePropertyDetailsContent
                id={id}
                slug={slug}
                initialGuests={initialGuests}
                initialCheckin={initialCheckin}
                initialCheckout={initialCheckout}
                propertiesDetailsData={propertiesDetailsData}
                propertiesDetailsLoading={propertiesDetailsLoading}
                showGuestsDropdownMobile={showGuestsDropdownMobile}
                setShowGuestsDropdownMobile={setShowGuestsDropdownMobile}
                isLong={isLong}
                words={words}
                isReviewsLoading={isReviewsLoading}
                reviewsData={reviewsData}
                reviewCategoriesMobile={reviewCategoriesMobile}
                platformDataMobile={platformDataMobile}
                skeletonData={skeletonData}
                totalReviewCount={reviewCounts.totalCount}
              />

              <DesktopPropertyDetailsContent
                id={id}
                propertiesDetailsData={propertiesDetailsData}
                propertiesDetailsLoading={propertiesDetailsLoading}
                words={words}
                isLong={isLong}
                propertyDetails={propertyDetails}
                isReviewsLoading={isReviewsLoading}
                reviewsData={reviewsData}
                totalReviewCount={reviewCounts.totalCount}
                reviewCategories={reviewCategories}
                platformData={platformData}
                skeletonData={skeletonData}
              />
            </div>

            <DesktopBookingSidebar
              id={id}
              initialGuests={initialGuests}
              initialCheckin={initialCheckin}
              initialCheckout={initialCheckout}
              propertiesDetailsData={propertiesDetailsData}
              propertiesDetailsLoading={propertiesDetailsLoading}
              showGuestsDropdown={showGuestsDropdown}
              setShowGuestsDropdown={setShowGuestsDropdown}
            />
          </div>

          <SimilarProperties
            similarPropertyIsLoading={isSimilarLoading}
            similarPropertyData={similarPropertiesData}
          />
        </SectionContainer>
      </section>
    </div>
  )
}


PropertyDetailsSectionWrapper.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  initialGuests: PropTypes.number,
  initialCheckin: PropTypes.string,
  initialCheckout: PropTypes.string,

  propertiesDetailsData: PropTypes.shape({
    data: PropTypes.object,
  }),

  propertiesDetailsLoading: PropTypes.bool.isRequired,

  /** ✅ FIX STARTS HERE */
  reviewsDataNewProps: PropTypes.shape({
    data: PropTypes.shape({
      hosfully_review_count: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
      ]),
      airbnb_review_count: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
      ]),
      count: PropTypes.number,
    }),
  }),
  /** ✅ FIX ENDS HERE */

  loadingReviews: PropTypes.bool.isRequired,

  similarData: PropTypes.any,
  loadingSimilar: PropTypes.bool.isRequired,
}


export default PropertyDetailsSectionWrapper
